import React from 'react';
import { Quote } from 'lucide-react';

const AboutFounder = () => {
  return (
    <section className="py-16 md:py-24 bg-slate-950 relative overflow-hidden">
      {/* Background Elements */}
      <div className="absolute inset-0">
        <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-emerald-500/30 to-transparent" />
        <div className="absolute bottom-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-cyan-500/30 to-transparent" />
        <div className="absolute top-1/2 left-0 w-[400px] h-[400px] bg-emerald-500/5 rounded-full blur-3xl -translate-y-1/2" />
        <div className="absolute top-1/2 right-0 w-[400px] h-[400px] bg-cyan-500/5 rounded-full blur-3xl -translate-y-1/2" />
      </div>

      <div className="relative z-10 max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12">
          <p className="text-emerald-400 text-sm font-semibold uppercase tracking-wider mb-3">Meet The Founder</p>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white">
            A Message From <span className="text-cyan-400">Roe Hubbard</span>
          </h2>
        </div>

        {/* Content Grid */}
        <div className="grid lg:grid-cols-5 gap-8 lg:gap-12 items-center">
          {/* Image Column */}
          <div className="lg:col-span-2 flex justify-center">
            <div className="relative">
              {/* Glow Effect */}
              <div className="absolute inset-0 bg-gradient-to-br from-emerald-500/30 to-cyan-500/30 rounded-2xl blur-2xl transform scale-105" />
              
              {/* Image Container */}
              <div className="relative rounded-2xl overflow-hidden border-2 border-emerald-500/30 shadow-2xl max-w-[320px]">
                <img 
                  src="/roe_hubbard.png" 
                  alt="Roe Hubbard - Founder of One Force Live" 
                  className="w-full h-auto"
                />
              </div>

              {/* Floating Badge */}
              <div className="absolute -bottom-3 -right-3 bg-gradient-to-r from-emerald-500 to-emerald-600 text-slate-950 font-bold px-4 py-2 rounded-xl text-sm shadow-lg">
                25+ Years Experience
              </div>
            </div>
          </div>

          {/* Text Column */}
          <div className="lg:col-span-3 space-y-6">
            {/* Quote Icon */}
            <Quote className="w-10 h-10 text-emerald-500/40" />

            {/* Introduction */}
            <p className="text-xl md:text-2xl text-white font-medium leading-relaxed">
              I'm <span className="text-emerald-400 font-bold">Roe Hubbard</span>, the owner, founder, engineer, artist, and business coach of One Force Live.
            </p>

            {/* Story */}
            <p className="text-lg text-slate-300 leading-relaxed">
              I've spent the last 25 years helping businesses generate over <span className="text-cyan-400 font-semibold">$100 million in sales and funding</span>. Now my mission is simple: give business owners the technology, support, and capital they need to grow faster and become the go-to brand in their market.
            </p>

            <p className="text-lg text-slate-300 leading-relaxed">
              With our <span className="text-emerald-400 font-semibold">AI Horse-Powered platform</span> and our <span className="text-cyan-400 font-semibold">$120,000 Co-Op Funding</span>, we help businesses stay fully visible, fully supported, and never worry about where their next lead is coming from.
            </p>

            {/* Signature Quote */}
            <div className="pt-4 border-t border-slate-800">
              <p className="text-xl md:text-2xl text-white italic font-medium">
                "I like to say… we take you out of the <span className="text-slate-400">rat race</span> and put you into a <span className="text-emerald-400">horse race</span>."
              </p>
              <p className="text-emerald-400 font-semibold mt-3">— Roe Hubbard, Founder</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutFounder;
